/* eslint-disable no-lone-blocks */
import axios from 'axios'
import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {toast} from 'react-toastify'
import {ENV} from '../../../Utils/_helpers/EnvHelper'

const API_URL = ENV().REACT_APP_API_URL
const initialState = {
  refreshToken: {},
}

export const fetchAsyncRefreshToken: any = createAsyncThunk(
  'refreshToken/fetchAsyncRefreshToken',
  async (data) => {
    const response = await axios.post(`${API_URL}auth/accessToken`, data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    return response.data
  }
)

const refreshTokenSlice = createSlice({
  name: 'refreshToken',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchAsyncRefreshToken.pending]: (state) => {},
    [fetchAsyncRefreshToken.fulfilled]: (state, {payload}) => {
      {
        payload.status === true
          ? toast.success('Your token has been Re-Genrated')
          : toast.error(payload.message)
      }
      return {...state, refreshToken: payload}
    },
    [fetchAsyncRefreshToken.rejected]: () => {},
  },
})

export default refreshTokenSlice.reducer
